import { Timeline, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent } from '@material-ui/lab';
import React, { FC } from 'react';
import { SerialNumberHistoryItem } from './SerialNumberHistoryItem';
import { HistorySnapshot } from './serialNumbers';

export const SerialNumberHistoryTimeline: FC<{history: HistorySnapshot[], isLoading?: boolean}> = ({history, isLoading}) => (
    <Timeline align="alternate">
        {
            isLoading ?
                ([0, 1, 2].map((value, key) => <SerialNumberHistoryItem index={value} key={key} />)) :
                (history.map((snapshot, key) => <SerialNumberHistoryItem index={key} key={key} snapshot={snapshot} />))
        }
        <TimelineItem>
            <TimelineOppositeContent />
            <TimelineDot variant="outlined" />
            <TimelineContent />
        </TimelineItem>
    </Timeline>
)
